import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import * as Api from '@ViewModels';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta, reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'emailExecAssistant/digests/latest';

export const useLatestEmailExecDigestQuery = ({
	enabled,
	meta,
}: {
	enabled?: boolean;
	meta?: LevStandardQueryMeta;
} = {}) => {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryKey: [BASE_QUERY_KEY],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IEmailExecDigest>({
				path: 'emailExecAssistant/digests/latest',
				method: 'GET',
				throwOn404: false,
			}),
		meta,
	});
};

export const useLatestEmailExecDigestSuspenseQuery = ({ meta }: { meta?: LevStandardQueryMeta } = {}) => {
	const userSession = useUserSession();
	return useSuspenseQuery({
		queryKey: [BASE_QUERY_KEY],
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.IEmailExecDigest>({
				path: 'emailExecAssistant/digests/latest',
				method: 'GET',
				throwOn404: false,
			}),
		meta,
	});
};

export const invalidateLatestEmailExecDigest = () => reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
